const ForgotPasswordConstants = {
	FORGOT_REQUEST: 'FORGOT_REQUEST',
	FORGOT_SUCCESS: 'FORGOT_SUCCESS',
	FORGOT_FAILURE: 'FORGOT_FAILURE',
}

export default ForgotPasswordConstants;
